import { useEffect, useState } from "react";
import { productEnrichment } from "../mock/mock";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let _cache = null; // module-level cache to avoid refetching across pages

const stripHtml = (html = "") =>
  html
    .replace(/<[^>]*>/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const merge = (p) => {
  const e = productEnrichment[p.handle] || {};
  return {
    ...p,
    slug: p.handle,
    name: e.shortName || p.title,
    fullTitle: p.title,
    family: e.family || p.product_type || "Extrait de Parfum",
    subtitle: e.subtitle || "Limited Edition",
    rating: e.rating || 5.0,
    reviews: e.reviews || 0,
    category: e.category || "Unisex",
    concentration: e.concentration || "Extrait de Parfum",
    size: e.size || "50 ml",
    badge: e.badge || "Limited",
    top: e.top || [],
    heart: e.heart || [],
    base: e.base || [],
    ingredientsImage: e.ingredientsImage || null,
    order: e.order ?? 999,
    description: e.description || stripHtml(p.description_html).slice(0, 260),
    descriptionHtml: p.description_html || "",
    oldPrice: null,
    // Buy action → real Shopify cart/checkout permalink
    checkoutUrl: p.checkout_url,
    productUrl: p.product_url,
    images: Array.isArray(p.images) ? p.images : [],
  };
};

const fetchProducts = async () => {
  if (_cache) return _cache;
  const res = await fetch(`${API}/shop/products`);
  if (!res.ok) throw new Error("Fehler beim Laden der Produkte");
  const data = await res.json();
  const products = (data.products || []).map(merge);
  products.sort((a, b) => a.order - b.order);
  _cache = products;
  return products;
};

export const useProducts = () => {
  const [products, setProducts] = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    fetchProducts()
      .then((p) => active && (setProducts(p), setLoading(false)))
      .catch((e) => active && (setError(e.message), setLoading(false)));
    return () => {
      active = false;
    };
  }, []);

  return { products, loading, error };
};

export const useProduct = (slug) => {
  const { products, loading, error } = useProducts();
  const product = products.find((p) => p.slug === slug) || null;
  return { product, products, loading, error };
};
